import { useDictionary } from '@wildscreen/core/src/core';
import * as React from 'react';
import { Helmet } from 'react-helmet';

import { UserAgreement } from '../../components/userAgreement';

export const PrivacyPolicy: React.FC = () => {
  const { arkive } = useDictionary('en');
  const { heading, description, content } = arkive.unauthenticated.views.privacyPolicy;

  return (
    <>
      <Helmet>
        <title>{heading}</title>
        <meta name="description" content={description} />
      </Helmet>
      <UserAgreement heading={heading}>{content()}</UserAgreement>
    </>
  );
};
